module.exports = __webpack_public_path__ + "img/ic_ky.cf21715b.png";